import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Simple lazy loading without complex retry logic
const HomePage = lazy(() => import('../pages/home/page'));
const SignInPage = lazy(() => import('../pages/auth/signin/page'));
const SignUpPage = lazy(() => import('../pages/auth/signup/page'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password/page'));
const EmailVerificationPage = lazy(() => import('../pages/email-verification/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const WalletPage = lazy(() => import('../pages/wallet/page'));
const TradingPage = lazy(() => import('../pages/trading/page'));
const StakingPage = lazy(() => import('../pages/staking/page'));
const MiningPage = lazy(() => import('../pages/mining/page'));
const P2PPage = lazy(() => import('../pages/p2p/page'));
const MerchantsPage = lazy(() => import('../pages/merchants/page'));
const ReferralPage = lazy(() => import('../pages/referral/page'));
const GamePage = lazy(() => import('../pages/game/page'));
const InvestmentPage = lazy(() => import('../pages/investment/page'));
const RobotPage = lazy(() => import('../pages/robot/page'));
const ArbitragePage = lazy(() => import('../pages/arbitrage/page'));
const CalculatorPage = lazy(() => import('../pages/calculator/page'));
const PepVersePage = lazy(() => import('../pages/pepverse/page'));
const WhitepaperPage = lazy(() => import('../pages/whitepaper/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const HelpPage = lazy(() => import('../pages/help/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const RiskDisclosurePage = lazy(() => import('../pages/risk-disclosure/page'));
const FeesPage = lazy(() => import('../pages/fees/page'));
const KYCPage = lazy(() => import('../pages/kyc/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin-dashboard/page'));
const ExecutivePage = lazy(() => import('../pages/executive/page'));
const MerchantApplicationPage = lazy(() => import('../pages/merchant-application/page'));
const MerchantAccountSetupPage = lazy(() => import('../pages/merchant-account-setup/page'));
const MerchantDebtPage = lazy(() => import('../pages/merchant-debt/page'));
const ManualPaymentPage = lazy(() => import('../pages/payment/manual/page'));
const BuySellPepCoinPage = lazy(() => import('../pages/pepcoin/buy-sell/page'));
const APIDocsPage = lazy(() => import('../pages/api-docs/page'));
const ProofConfirmationPage = lazy(() => import('../pages/p2p/proof-confirmation/page'));
const MerchantOrdersPage = lazy(() => import('../pages/merchant-orders/page'));
const MerchantProfilePage = lazy(() => import('../pages/merchant-profile/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth/signin',
    element: <SignInPage />,
  },
  {
    path: '/signin',
    element: <SignInPage />,
  },
  {
    path: '/auth/signup',
    element: <SignUpPage />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
  },
  {
    path: '/auth/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/email-verification',
    element: <EmailVerificationPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/wallet',
    element: <WalletPage />,
  },
  {
    path: '/trading',
    element: <TradingPage />,
  },
  {
    path: '/staking',
    element: <StakingPage />,
  },
  {
    path: '/mining',
    element: <MiningPage />,
  },
  {
    path: '/p2p',
    element: <P2PPage />,
  },
  {
    path: '/merchants',
    element: <MerchantsPage />,
  },
  {
    path: '/p2p/proof-confirmation',
    element: <ProofConfirmationPage />,
  },
  {
    path: '/merchant-orders/:orderId',
    element: <MerchantOrdersPage />,
  },
  {
    path: '/referral',
    element: <ReferralPage />,
  },
  {
    path: '/game',
    element: <GamePage />,
  },
  {
    path: '/investment',
    element: <InvestmentPage />,
  },
  {
    path: '/robot',
    element: <RobotPage />,
  },
  {
    path: '/arbitrage',
    element: <ArbitragePage />,
  },
  {
    path: '/calculator',
    element: <CalculatorPage />,
  },
  {
    path: '/pepverse',
    element: <PepVersePage />,
  },
  {
    path: '/whitepaper',
    element: <WhitepaperPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/help',
    element: <HelpPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/risk-disclosure',
    element: <RiskDisclosurePage />,
  },
  {
    path: '/fees',
    element: <FeesPage />,
  },
  {
    path: '/kyc',
    element: <KYCPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/admin-dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/executive',
    element: <ExecutivePage />,
  },
  {
    path: '/merchant-application',
    element: <MerchantApplicationPage />,
  },
  {
    path: '/merchant-account-setup',
    element: <MerchantAccountSetupPage />,
  },
  {
    path: '/merchant-debt',
    element: <MerchantDebtPage />,
  },
  {
    path: '/payment/manual',
    element: <ManualPaymentPage />,
  },
  {
    path: '/pepcoin/buy-sell',
    element: <BuySellPepCoinPage />,
  },
  {
    path: '/api-docs',
    element: <APIDocsPage />,
  },
  {
    path: '/merchant-profile',
    element: <MerchantProfilePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
